// import React, { useEffect, useState } from "react";
// import "./ManageUsers.css";

// const ManageUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showPortfolioModal, setShowPortfolioModal] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [companies, setCompanies] = useState([]);
//   const [currencies, setCurrencies] = useState([]);
//   const [portfolios, setPortfolios] = useState([]);
//   const [toastMessage, setToastMessage] = useState("");

//   // Track user IDs who already have portfolios
//   const [usersWithPortfolio, setUsersWithPortfolio] = useState(new Set());

//   // Add User modal states
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [newUser, setNewUser] = useState({
//     username: "",
//     email: "",
//     password: "",
//     mobilenumber: "",
//   });

//   useEffect(() => {
//     fetchUsers();
//     fetchCompanies();
//     fetchCurrencies();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await fetch("/api/admin/users");
//       const data = await res.json();
//       setUsers(data.users || []);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   const fetchCompanies = async () => {
//     try {
//       const res = await fetch("/api/admin/companies");
//       const data = await res.json();
//       setCompanies(data.companies || []);
//     } catch (error) {
//       console.error("Error fetching companies:", error);
//     }
//   };

//   const fetchCurrencies = async () => {
//     try {
//       const res = await fetch("/api/admin/currencies");
//       const data = await res.json();
//       setCurrencies(data.currencies || []);
//     } catch (error) {
//       console.error("Error fetching currencies:", error);
//     }
//   };

//   const initializePortfolios = (user) => {
//     const initialPortfolios = companies.map((company) => ({
//       user: user._id,
//       company: company._id,
//       investedAmount: "",
//       withdrawal: "",
//       currentValue: "",
//       thismonthpnl: "",
//       currency: "",
//       updatedDate: new Date().toISOString().split("T")[0], // Individual date for each row
//     }));
//     setPortfolios(initialPortfolios);
//   };

//   const handlePortfolioChange = (index, field, value) => {
//     const updatedPortfolios = [...portfolios];
//     updatedPortfolios[index] = {
//       ...updatedPortfolios[index],
//       [field]: value,
//     };
//     setPortfolios(updatedPortfolios);
//   };

//   const handlePortfolioSubmit = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) throw new Error("No auth token found. Please login.");

//       const validPortfolios = portfolios
//         .filter(
//           (p) =>
//             p.currency &&
//             p.investedAmount !== "" &&
//             !isNaN(Number(p.investedAmount)) &&
//             p.withdrawal !== "" &&
//             !isNaN(Number(p.withdrawal)) &&
//             p.currentValue !== "" &&
//             !isNaN(Number(p.currentValue)) &&
//             p.thismonthpnl !== "" &&
//             !isNaN(Number(p.thismonthpnl)) &&
//             p.updatedDate // Ensure date is present
//         )
//         .map((p) => ({
//           user: p.user,
//           company: p.company,
//           currency: p.currency,
//           investedAmount: Number(p.investedAmount),
//           withdrawal: Number(p.withdrawal),
//           currentValue: Number(p.currentValue),
//           thismonthpnl: Number(p.thismonthpnl),
//           updatedDate: p.updatedDate, // Individual date for each portfolio
//         }));

//       if (validPortfolios.length === 0) {
//         showToast("Please fill at least one complete portfolio entry.");
//         return;
//       }

//       const res = await fetch("/api/admin/portfolio/bulk", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(validPortfolios),
//       });

//       if (!res.ok) {
//         const errorData = await res.json();
//         throw new Error(errorData.message || "Failed to update portfolios");
//       }

//       showToast("Portfolios updated successfully!");
//       setShowPortfolioModal(false);

//       // Mark the selected user as having a portfolio now
//       setUsersWithPortfolio((prev) => new Set(prev).add(selectedUser._id));
//     } catch (error) {
//       console.error("Error updating portfolios:", error);
//       showToast(`Error: ${error.message}`);
//     }
//   };

//   const showToast = (message) => {
//     setToastMessage(message);
//     setTimeout(() => setToastMessage(""), 3000);
//   };

//   // Handle Add User form change
//   const handleAddUserChange = (e) => {
//     const { name, value } = e.target;
//     setNewUser((prev) => ({ ...prev, [name]: value }));
//   };

//   // Submit handler for Add User form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem("token");

//     try {
//       const res = await fetch("/api/admin/users", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(newUser),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Failed to add user");

//       showToast("User added successfully!");
//       setShowAddModal(false);
//       setNewUser({ username: "", email: "", password: "", mobilenumber: "" });
//       fetchUsers();
//     } catch (error) {
//       showToast(`Error: ${error.message}`);
//     }
//   };

//   const filteredUsers = users.filter((user) =>
//     `${user.username} ${user.email} ${user.mobilenumber || ""}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="manage-users">
//       <div className="header-row">
//         <h2 className="title">Manage Users</h2>
//         <div className="actions">
//           <input
//             type="text"
//             placeholder="Search by name, email, or mobile..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <button
//             className="add-user-btn"
//             onClick={() => setShowAddModal(true)}
//           >
//             + Add User
//           </button>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="users-table">
//           <thead>
//             <tr>
//               <th>Username</th>
//               <th>Email</th>
//               <th>Mobile</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredUsers.map((user) => (
//               <tr key={user._id}>
//                 <td>{user.username}</td>
//                 <td>{user.email}</td>
//                 <td>{user.mobilenumber || "N/A"}</td>
//                 <td>
//                   <button
//                     className="btn portfolio add-portfolio"
//                     onClick={() => {
//                       setSelectedUser(user);
//                       initializePortfolios(user);
//                       setShowPortfolioModal(true);
//                     }}
//                     disabled={usersWithPortfolio.has(user._id)}
//                     title={
//                       usersWithPortfolio.has(user._id)
//                         ? "Portfolio already added"
//                         : "Add portfolio"
//                     }
//                   >
//                     Add Portfolio
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Portfolio Modal */}
//       {showPortfolioModal && (
//         <div className="modal-overlay">
//           <div className="modal portfolio-modal">
//             <div className="modal-header">
//               <h3>Add Portfolio for {selectedUser?.username}</h3>
//             </div>

//             <div className="table-wrapper">
//               <table className="portfolio-table">
//                 <thead>
//                   <tr>
//                     <th>Company</th>
//                     <th>Invested</th>
//                     <th>Withdrawal</th>
//                     <th>Current Value</th>
//                     <th>This Month PNL</th>
//                     <th>Currency</th>
//                     <th>Updated Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {portfolios.map((portfolio, index) => (
//                     <tr key={index}>
//                       <td>
//                         {companies.find((c) => c._id === portfolio.company)
//                           ?.name || "N/A"}
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           min="0"
//                           step="any"
//                           pattern="[0-9]*"
//                           inputMode="numeric"
//                           value={portfolio.investedAmount}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "investedAmount",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           min="0"
//                           step="any"
//                           pattern="[0-9]*"
//                           inputMode="numeric"
//                           value={portfolio.withdrawal}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "withdrawal",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           min="0"
//                           step="any"
//                           pattern="[0-9]*"
//                           inputMode="numeric"
//                           value={portfolio.currentValue}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "currentValue",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           step="any"
//                           pattern="[0-9]*"
//                           inputMode="numeric"
//                           value={portfolio.thismonthpnl}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "thismonthpnl",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                         />
//                       </td>
//                       <td>
//                         <select
//                           value={portfolio.currency}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "currency",
//                               e.target.value
//                             )
//                           }
//                         >
//                           <option value="">Select Currency</option>
//                           {currencies.map((currency) => (
//                             <option key={currency._id} value={currency._id}>
//                               {currency.code}
//                             </option>
//                           ))}
//                         </select>
//                       </td>
//                       <td>
//                         <input
//                           type="date"
//                           value={portfolio.updatedDate}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "updatedDate",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="form-actions">
//               <button className="btn-primary" onClick={handlePortfolioSubmit}>
//                 Update Portfolios
//               </button>
//               <button onClick={() => setShowPortfolioModal(false)}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add User Modal */}
//       {showAddModal && (
//         <div className="modal-overlay">
//           <div className="modal">
//             <h3>Add New User</h3>
//             <form onSubmit={handleSubmit} className="add-user-form">
//               <label>
//                 Username:
//                 <input
//                   type="text"
//                   name="username"
//                   value={newUser.username}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Email:
//                 <input
//                   type="email"
//                   name="email"
//                   value={newUser.email}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Mobile Number:
//                 <input
//                   type="text"
//                   name="mobilenumber"
//                   value={newUser.mobilenumber}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Password:
//                 <input
//                   type="password"
//                   name="password"
//                   value={newUser.password}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <div className="form-actions">
//                 <button type="submit">Add User</button>
//                 <button type="button" onClick={() => setShowAddModal(false)}>
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Toast message */}
//       {toastMessage && <div className="toast">{toastMessage}</div>}
//     </div>
//   );
// };

// export default ManageUsers;
// import React, { useEffect, useState } from "react";
// import "./ManageUsers.css";

// const ManageUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showPortfolioModal, setShowPortfolioModal] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [companies, setCompanies] = useState([]);
//   const [currencies, setCurrencies] = useState([]);
//   const [portfolios, setPortfolios] = useState([]);
//   const [toastMessage, setToastMessage] = useState("");

//   // Track user IDs who already have portfolios
//   const [usersWithPortfolio, setUsersWithPortfolio] = useState(new Set());

//   // Add User  states
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [newUser, setNewUser] = useState({
//     username: "",
//     email: "",
//     password: "",
//     mobilenumber: "",
//   });

//   useEffect(() => {
//     fetchUsers();
//     fetchCompanies();
//     fetchCurrencies();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await fetch("/api/admin/users");
//       const data = await res.json();
//       setUsers(data.users || []);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   const fetchCompanies = async () => {
//     try {
//       const res = await fetch("/api/admin/companies");
//       const data = await res.json();
//       setCompanies(data.companies || []);
//     } catch (error) {
//       console.error("Error fetching companies:", error);
//     }
//   };

//   const fetchCurrencies = async () => {
//     try {
//       const res = await fetch("/api/admin/currencies");
//       const data = await res.json();
//       setCurrencies(data.currencies || []);
//     } catch (error) {
//       console.error("Error fetching currencies:", error);
//     }
//   };

//   // Function to calculate derived values
//   const calculateDerivedValues = (
//     investedAmount,
//     withdrawal,
//     monthlyPnlPercentage
//   ) => {
//     const invested = parseFloat(investedAmount) || 0;
//     const withdrawalAmt = parseFloat(withdrawal) || 0;
//     const monthlyPnlPerc = parseFloat(monthlyPnlPercentage) || 0;

//     // Calculate This Month PNL
//     const thisMonthPnl = (invested * monthlyPnlPerc) / 100;

//     // Calculate Current Value
//     const currentValue = invested - withdrawalAmt + thisMonthPnl;

//     // Calculate Profit Percentage - CORRECT FORMULA
//     const profitPercentage =
//       invested > 0
//         ? ((currentValue + withdrawalAmt - invested) / invested) * 100
//         : 0;

//     return {
//       thisMonthPnl: thisMonthPnl.toFixed(2),
//       currentValue: currentValue.toFixed(2),
//       profitPercentage: profitPercentage.toFixed(1),
//     };
//   };

//   const initializePortfolios = (user) => {
//     const initialPortfolios = companies.map((company) => ({
//       user: user._id,
//       company: company._id,
//       investedAmount: "",
//       withdrawal: "",
//       monthlyPnlPercentage: "",
//       currentValue: "",
//       thismonthpnl: "",
//       profitPercentage: "", // Add profitPercentage field
//       currency: "",
//       updatedDate: new Date().toISOString().split("T")[0], // Individual date for each row
//     }));
//     setPortfolios(initialPortfolios);
//   };

//   const handlePortfolioChange = (index, field, value) => {
//     const updatedPortfolios = [...portfolios];

//     // Validate numeric inputs
//     if (
//       field === "investedAmount" ||
//       field === "withdrawal" ||
//       field === "monthlyPnlPercentage"
//     ) {
//       if (value === "" || /^[-+]?\d*\.?\d*$/.test(value)) {
//         updatedPortfolios[index][field] = value;

//         // Calculate derived values when any of these fields change
//         const invested = updatedPortfolios[index].investedAmount || 0;
//         const withdrawal = updatedPortfolios[index].withdrawal || 0;
//         const monthlyPnlPerc =
//           updatedPortfolios[index].monthlyPnlPercentage || 0;

//         const derived = calculateDerivedValues(
//           invested,
//           withdrawal,
//           monthlyPnlPerc
//         );

//         updatedPortfolios[index].thismonthpnl = derived.thisMonthPnl;
//         updatedPortfolios[index].currentValue = derived.currentValue;
//         updatedPortfolios[index].profitPercentage = parseFloat(
//           derived.profitPercentage
//         );
//       }
//     } else if (field === "updatedDate" || field === "currency") {
//       updatedPortfolios[index][field] = value;
//     }

//     setPortfolios(updatedPortfolios);
//   };

//   const handlePortfolioSubmit = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) throw new Error("No auth token found. Please login.");

//       const validPortfolios = portfolios
//         .filter(
//           (p) =>
//             p.currency &&
//             p.investedAmount !== "" &&
//             !isNaN(Number(p.investedAmount)) &&
//             p.withdrawal !== "" &&
//             !isNaN(Number(p.withdrawal)) &&
//             p.monthlyPnlPercentage !== "" &&
//             !isNaN(Number(p.monthlyPnlPercentage)) &&
//             p.updatedDate // Ensure date is present
//         )
//         .map((p) => {
//           // Recalculate to ensure accuracy before sending
//           const invested = parseFloat(p.investedAmount) || 0;
//           const withdrawalAmt = parseFloat(p.withdrawal) || 0;
//           const monthlyPnlPerc = parseFloat(p.monthlyPnlPercentage) || 0;

//           const derived = calculateDerivedValues(
//             invested,
//             withdrawalAmt,
//             monthlyPnlPerc
//           );

//           return {
//             user: p.user,
//             company: p.company,
//             currency: p.currency,
//             investedAmount: invested,
//             withdrawal: withdrawalAmt,
//             currentValue: parseFloat(derived.currentValue),
//             thismonthpnl: parseFloat(derived.thisMonthPnl),
//             monthlyPnlPercentage: monthlyPnlPerc,
//             profitPercentage: parseFloat(derived.profitPercentage), // Add profitPercentage
//             updatedDate: p.updatedDate, // Individual date for each portfolio
//           };
//         });

//       if (validPortfolios.length === 0) {
//         showToast("Please fill at least one complete portfolio entry.");
//         return;
//       }

//       const res = await fetch("/api/admin/portfolio/bulk", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(validPortfolios),
//       });

//       if (!res.ok) {
//         const errorData = await res.json();
//         throw new Error(errorData.message || "Failed to update portfolios");
//       }

//       showToast("Portfolios updated successfully!");
//       setShowPortfolioModal(false);

//       // Mark the selected user as having a portfolio now
//       setUsersWithPortfolio((prev) => new Set(prev).add(selectedUser._id));
//     } catch (error) {
//       console.error("Error updating portfolios:", error);
//       showToast(`Error: ${error.message}`);
//     }
//   };

//   const showToast = (message) => {
//     setToastMessage(message);
//     setTimeout(() => setToastMessage(""), 3000);
//   };

//   // Handle Add User form change
//   const handleAddUserChange = (e) => {
//     const { name, value } = e.target;
//     setNewUser((prev) => ({ ...prev, [name]: value }));
//   };

//   // Submit handler for Add User form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const token = localStorage.getItem("token");

//     try {
//       const res = await fetch("/api/admin/users", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(newUser),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Failed to add user");

//       showToast("User added successfully!");
//       setShowAddModal(false);
//       setNewUser({ username: "", email: "", password: "", mobilenumber: "" });
//       fetchUsers();
//     } catch (error) {
//       showToast(`Error: ${error.message}`);
//     }
//   };

//   const filteredUsers = users.filter((user) =>
//     `${user.username} ${user.email} ${user.mobilenumber || ""}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="manage-users">
//       <div className="header-row">
//         <h2 className="title">Manage Users</h2>
//         <div className="actions">
//           <input
//             type="text"
//             placeholder="Search by name, email, or mobile..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <button
//             className="add-user-btn"
//             onClick={() => setShowAddModal(true)}
//           >
//             + Add User
//           </button>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="users-table">
//           <thead>
//             <tr>
//               <th>Username</th>
//               <th>Email</th>
//               <th>Mobile</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredUsers.map((user) => (
//               <tr key={user._id}>
//                 <td>{user.username}</td>
//                 <td>{user.email}</td>
//                 <td>{user.mobilenumber || "N/A"}</td>
//                 <td>
//                   <button
//                     className="btn portfolio add-portfolio"
//                     onClick={() => {
//                       setSelectedUser(user);
//                       initializePortfolios(user);
//                       setShowPortfolioModal(true);
//                     }}
//                     disabled={usersWithPortfolio.has(user._id)}
//                     title={
//                       usersWithPortfolio.has(user._id)
//                         ? "Portfolio already added"
//                         : "Add portfolio"
//                     }
//                   >
//                     Add Portfolio
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Portfolio Modal */}
//       {showPortfolioModal && (
//         <div className="modal-overlay">
//           <div className="modal portfolio-modal">
//             <div className="modal-header">
//               <h3>Add Portfolio for {selectedUser?.username}</h3>
//               <p className="calculation-note">
//                 <strong>Note:</strong> Enter Invested, Withdrawal, and Monthly
//                 PNL%. Current Value, This Month PNL, and Profit% will be
//                 calculated automatically.
//               </p>
//             </div>

//             <div className="table-wrapper">
//               <table className="portfolio-table">
//                 <thead>
//                   <tr>
//                     <th>Company</th>
//                     <th>Invested</th>
//                     <th>Withdrawal</th>
//                     <th>Monthly PNL%</th>
//                     <th>Current Value</th>
//                     <th>This Month PNL</th>
//                     <th>Profit%</th>
//                     <th>Currency</th>
//                     <th>Updated Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {portfolios.map((portfolio, index) => (
//                     <tr key={index}>
//                       <td>
//                         {companies.find((c) => c._id === portfolio.company)
//                           ?.name || "N/A"}
//                       </td>
//                       <td>
//                         <input
//                           type="text"
//                           value={portfolio.investedAmount}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "investedAmount",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                           className="portfolio-input"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="text"
//                           value={portfolio.withdrawal}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "withdrawal",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                           className="portfolio-input"
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="text"
//                           value={portfolio.monthlyPnlPercentage}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "monthlyPnlPercentage",
//                               e.target.value
//                             )
//                           }
//                           placeholder="0.00"
//                           className="portfolio-input"
//                         />
//                       </td>
//                       <td className="calculated-value">
//                         {portfolio.currentValue || "0.00"}
//                       </td>
//                       <td className="calculated-value">
//                         {portfolio.thismonthpnl || "0.00"}
//                       </td>
//                       <td className="calculated-value">
//                         {portfolio.profitPercentage || "0.0"}%
//                       </td>
//                       <td>
//                         <select
//                           value={portfolio.currency}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "currency",
//                               e.target.value
//                             )
//                           }
//                           className="portfolio-select"
//                         >
//                           <option value="">Select Currency</option>
//                           {currencies.map((currency) => (
//                             <option key={currency._id} value={currency._id}>
//                               {currency.code}
//                             </option>
//                           ))}
//                         </select>
//                       </td>
//                       <td>
//                         <input
//                           type="date"
//                           value={portfolio.updatedDate}
//                           onChange={(e) =>
//                             handlePortfolioChange(
//                               index,
//                               "updatedDate",
//                               e.target.value
//                             )
//                           }
//                           className="portfolio-date"
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="form-actions">
//               <button className="btn-primary" onClick={handlePortfolioSubmit}>
//                 Update Portfolios
//               </button>
//               <button onClick={() => setShowPortfolioModal(false)}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add User Modal */}
//       {showAddModal && (
//         <div className="modal-overlay">
//           <div className="modal">
//             <h3>Add New User</h3>
//             <form onSubmit={handleSubmit} className="add-user-form">
//               <label>
//                 Username:
//                 <input
//                   type="text"
//                   name="username"
//                   value={newUser.username}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Email:
//                 <input
//                   type="email"
//                   name="email"
//                   value={newUser.email}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Mobile Number:
//                 <input
//                   type="text"
//                   name="mobilenumber"
//                   value={newUser.mobilenumber}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <label>
//                 Password:
//                 <input
//                   type="password"
//                   name="password"
//                   value={newUser.password}
//                   onChange={handleAddUserChange}
//                   required
//                 />
//               </label>
//               <div className="form-actions">
//                 <button type="submit">Add User</button>
//                 <button type="button" onClick={() => setShowAddModal(false)}>
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Toast message */}
//       {toastMessage && <div className="toast">{toastMessage}</div>}
//     </div>
//   );
// };

// export default ManageUsers;
import React, { useEffect, useState } from "react";
import "./ManageUsers.css";

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPortfolioModal, setShowPortfolioModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [toastMessage, setToastMessage] = useState("");

  // Track user IDs who already have portfolios
  const [usersWithPortfolio, setUsersWithPortfolio] = useState(new Set());

  // Add User states
  const [showAddModal, setShowAddModal] = useState(false);
  const [newUser, setNewUser] = useState({
    username: "",
    email: "",
    password: "",
    mobilenumber: "",
  });

  useEffect(() => {
    fetchUsers();
    fetchCompanies();
    fetchCurrencies();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await fetch("/api/admin/users");
      const data = await res.json();
      setUsers(data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const res = await fetch("/api/admin/companies");
      const data = await res.json();
      setCompanies(data.companies || []);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await fetch("/api/admin/currencies");
      const data = await res.json();
      setCurrencies(data.currencies || []);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };

  // Function to calculate derived values
  const calculateDerivedValues = (
    investedAmount,
    withdrawal,
    monthlyPnlPercentage,
    previousPnl
  ) => {
    const invested = parseFloat(investedAmount) || 0;
    const withdrawalAmt = parseFloat(withdrawal) || 0;
    const monthlyPnlPerc = parseFloat(monthlyPnlPercentage) || 0;
    const previousPnlAmt = parseFloat(previousPnl) || 0;

    // Calculate This Month PNL
    const thisMonthPnl = (invested * monthlyPnlPerc) / 100;

    // Calculate Current Value (including previous PNL)
    const currentValue =
      invested - withdrawalAmt + thisMonthPnl + previousPnlAmt;

    // Calculate Profit Percentage - CORRECT FORMULA
    const profitPercentage =
      invested > 0
        ? ((currentValue + withdrawalAmt - invested) / invested) * 100
        : 0;

    return {
      thisMonthPnl: thisMonthPnl.toFixed(2),
      currentValue: currentValue.toFixed(2),
      profitPercentage: profitPercentage.toFixed(1),
    };
  };

  const initializePortfolios = (user) => {
    const initialPortfolios = companies.map((company) => ({
      user: user._id,
      company: company._id,
      investedAmount: "",
      withdrawal: "",
      monthlyPnlPercentage: "",
      previousPnl: "", // Added previousPnl field
      currentValue: "",
      thismonthpnl: "",
      profitPercentage: "",
      currency: "",
      updatedDate: new Date().toISOString().split("T")[0],
    }));
    setPortfolios(initialPortfolios);
  };

  const handlePortfolioChange = (index, field, value) => {
    const updatedPortfolios = [...portfolios];

    // Validate numeric inputs
    if (
      field === "investedAmount" ||
      field === "withdrawal" ||
      field === "monthlyPnlPercentage" ||
      field === "previousPnl"
    ) {
      if (value === "" || /^[-+]?\d*\.?\d*$/.test(value)) {
        updatedPortfolios[index][field] = value;

        // Calculate derived values when any of these fields change
        const invested = updatedPortfolios[index].investedAmount || 0;
        const withdrawal = updatedPortfolios[index].withdrawal || 0;
        const monthlyPnlPerc =
          updatedPortfolios[index].monthlyPnlPercentage || 0;
        const previousPnlAmt = updatedPortfolios[index].previousPnl || 0;

        const derived = calculateDerivedValues(
          invested,
          withdrawal,
          monthlyPnlPerc,
          previousPnlAmt
        );

        updatedPortfolios[index].thismonthpnl = derived.thisMonthPnl;
        updatedPortfolios[index].currentValue = derived.currentValue;
        updatedPortfolios[index].profitPercentage = parseFloat(
          derived.profitPercentage
        );
      }
    } else if (field === "updatedDate" || field === "currency") {
      updatedPortfolios[index][field] = value;
    }

    setPortfolios(updatedPortfolios);
  };

  const handlePortfolioSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No auth token found. Please login.");

      const validPortfolios = portfolios
        .filter(
          (p) =>
            p.currency &&
            p.investedAmount !== "" &&
            !isNaN(Number(p.investedAmount)) &&
            p.withdrawal !== "" &&
            !isNaN(Number(p.withdrawal)) &&
            p.monthlyPnlPercentage !== "" &&
            !isNaN(Number(p.monthlyPnlPercentage)) &&
            p.updatedDate
        )
        .map((p) => {
          // Recalculate to ensure accuracy before sending
          const invested = parseFloat(p.investedAmount) || 0;
          const withdrawalAmt = parseFloat(p.withdrawal) || 0;
          const monthlyPnlPerc = parseFloat(p.monthlyPnlPercentage) || 0;
          const previousPnlAmt = parseFloat(p.previousPnl) || 0;

          const derived = calculateDerivedValues(
            invested,
            withdrawalAmt,
            monthlyPnlPerc,
            previousPnlAmt
          );

          return {
            user: p.user,
            company: p.company,
            currency: p.currency,
            investedAmount: invested,
            withdrawal: withdrawalAmt,
            currentValue: parseFloat(derived.currentValue),
            thismonthpnl: parseFloat(derived.thisMonthPnl),
            previousPnl: previousPnlAmt, // Include previousPnl in the data sent to backend
            monthlyPnlPercentage: monthlyPnlPerc,
            profitPercentage: parseFloat(derived.profitPercentage),
            updatedDate: p.updatedDate,
          };
        });

      if (validPortfolios.length === 0) {
        showToast("Please fill at least one complete portfolio entry.");
        return;
      }

      const res = await fetch("/api/admin/portfolio/bulk", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(validPortfolios),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Failed to update portfolios");
      }

      showToast("Portfolios updated successfully!");
      setShowPortfolioModal(false);

      // Mark the selected user as having a portfolio now
      setUsersWithPortfolio((prev) => new Set(prev).add(selectedUser._id));
    } catch (error) {
      console.error("Error updating portfolios:", error);
      showToast(`Error: ${error.message}`);
    }
  };

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 3000);
  };

  // Handle Add User form change
  const handleAddUserChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handler for Add User form
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const res = await fetch("/api/admin/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newUser),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to add user");

      showToast("User added successfully!");
      setShowAddModal(false);
      setNewUser({ username: "", email: "", password: "", mobilenumber: "" });
      fetchUsers();
    } catch (error) {
      showToast(`Error: ${error.message}`);
    }
  };

  const filteredUsers = users.filter((user) =>
    `${user.username} ${user.email} ${user.mobilenumber || ""}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="manage-users">
      <div className="header-row">
        <h2 className="title">Manage Users</h2>
        <div className="actions">
          <input
            type="text"
            placeholder="Search by name, email, or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button
            className="add-user-btn"
            onClick={() => setShowAddModal(true)}
          >
            + Add User
          </button>
        </div>
      </div>

      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user._id}>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>{user.mobilenumber || "N/A"}</td>
                <td>
                  <button
                    className="btn portfolio add-portfolio"
                    onClick={() => {
                      setSelectedUser(user);
                      initializePortfolios(user);
                      setShowPortfolioModal(true);
                    }}
                    disabled={usersWithPortfolio.has(user._id)}
                    title={
                      usersWithPortfolio.has(user._id)
                        ? "Portfolio already added"
                        : "Add portfolio"
                    }
                  >
                    Add Portfolio
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Portfolio Modal */}
      {showPortfolioModal && (
        <div className="modal-overlay">
          <div className="modal portfolio-modal">
            <div className="modal-header">
              <h3>Add Portfolio for {selectedUser?.username}</h3>
              <p className="calculation-note">
                <strong>Note:</strong> Enter Invested, Withdrawal, Monthly PNL%,
                and Previous PNL. Current Value, This Month PNL, and Profit%
                will be calculated automatically.
              </p>
            </div>

            <div className="table-wrapper">
              <table className="portfolio-table">
                <thead>
                  <tr>
                    <th>Company</th>
                    <th>Invested</th>
                    <th>Withdrawal</th>
                    <th>Monthly PNL%</th>
                    <th>Previous PNL</th>
                    <th>Current Value</th>
                    <th>This Month PNL</th>
                    <th>Profit%</th>
                    <th>Currency</th>
                    <th>Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {portfolios.map((portfolio, index) => (
                    <tr key={index}>
                      <td>
                        {companies.find((c) => c._id === portfolio.company)
                          ?.name || "N/A"}
                      </td>
                      <td>
                        <input
                          type="text"
                          value={portfolio.investedAmount}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "investedAmount",
                              e.target.value
                            )
                          }
                          placeholder="0.00"
                          className="portfolio-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={portfolio.withdrawal}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "withdrawal",
                              e.target.value
                            )
                          }
                          placeholder="0.00"
                          className="portfolio-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={portfolio.monthlyPnlPercentage}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "monthlyPnlPercentage",
                              e.target.value
                            )
                          }
                          placeholder="0.00"
                          className="portfolio-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={portfolio.previousPnl || ""}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "previousPnl",
                              e.target.value
                            )
                          }
                          placeholder="0.00"
                          className="portfolio-input"
                        />
                      </td>
                      <td className="calculated-value">
                        {portfolio.currentValue || "0.00"}
                      </td>
                      <td className="calculated-value">
                        {portfolio.thismonthpnl || "0.00"}
                      </td>
                      <td className="calculated-value">
                        {portfolio.profitPercentage || "0.0"}%
                      </td>
                      <td>
                        <select
                          value={portfolio.currency}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "currency",
                              e.target.value
                            )
                          }
                          className="portfolio-select"
                        >
                          <option value="">Select Currency</option>
                          {currencies.map((currency) => (
                            <option key={currency._id} value={currency._id}>
                              {currency.code}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="date"
                          value={portfolio.updatedDate}
                          onChange={(e) =>
                            handlePortfolioChange(
                              index,
                              "updatedDate",
                              e.target.value
                            )
                          }
                          className="portfolio-date"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="form-actions">
              <button className="btn-primary" onClick={handlePortfolioSubmit}>
                Update Portfolios
              </button>
              <button onClick={() => setShowPortfolioModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add User Modal */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add New User</h3>
            <form onSubmit={handleSubmit} className="add-user-form">
              <label>
                Username:
                <input
                  type="text"
                  name="username"
                  value={newUser.username}
                  onChange={handleAddUserChange}
                  required
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={newUser.email}
                  onChange={handleAddUserChange}
                  required
                />
              </label>
              <label>
                Mobile Number:
                <input
                  type="text"
                  name="mobilenumber"
                  value={newUser.mobilenumber}
                  onChange={handleAddUserChange}
                  required
                />
              </label>
              <label>
                Password:
                <input
                  type="password"
                  name="password"
                  value={newUser.password}
                  onChange={handleAddUserChange}
                  required
                />
              </label>
              <div className="form-actions">
                <button type="submit">Add User</button>
                <button type="button" onClick={() => setShowAddModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Toast message */}
      {toastMessage && <div className="toast">{toastMessage}</div>}
    </div>
  );
};

export default ManageUsers;
